var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandCircleSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ECEFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2532 18.2531C27.2613 18.2531 28.8892 16.6294 28.8892 14.6265C28.8892 12.6237 27.2613 11 25.2532 11C23.2451 11 21.6172 12.6237 21.6172 14.6265C21.6172 16.6294 23.2451 18.2531 25.2532 18.2531Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6973 20.4531H15.9939C17.0968 20.4531 17.0968 20.9729 17.8362 22.0004C18.1188 22.517 18.5477 22.9392 19.0692 23.2143C19.5908 23.4895 20.182 23.6055 20.7692 23.5478C22.6114 23.5478 24.4052 23.5478 24.8173 26.1347",
    stroke: "#1E334E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5751 25.9426C18.5751 25.9426 23.8958 27.8284 28.053 24.4799C31.9314 21.3732 34.2705 21.8809 34.2705 23.0172C34.2705 24.1535 31.6647 26.3174 30.4042 27.3691C29.1438 28.4208 24.9139 30.8989 23.5443 30.9956C22.1747 31.0923 17.4843 29.5933 16.1026 29.4362C14.9685 29.3354 13.8258 29.3965 12.709 29.6175",
    stroke: "#1E334E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7209 17.707H8.01809C7.45581 17.707 7 18.1617 7 18.7225V29.5175C7 30.0783 7.45581 30.5329 8.01809 30.5329H10.7209C11.2831 30.5329 11.7389 30.0783 11.7389 29.5175V18.7225C11.7389 18.1617 11.2831 17.707 10.7209 17.707Z",
    stroke: "#1E334E",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1742 28.4439C10.4085 28.4439 10.5984 28.2544 10.5984 28.0208C10.5984 27.7871 10.4085 27.5977 10.1742 27.5977C9.93992 27.5977 9.75 27.7871 9.75 28.0208C9.75 28.2544 9.93992 28.4439 10.1742 28.4439Z",
    stroke: "#1E334E",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandCircleSingle);
export default __webpack_public_path__ + "static/media/hand-circle-single.f366979e18089ce6105e3a06259f5629.svg";
export { ForwardRef as ReactComponent };